export default __webpack_public_path__ + "static/media/Neophyte's Armbands of Supreme Decree.10226484.jpg";